import { render, staticRenderFns } from "./steps.vue?vue&type=template&id=6eea9872&scoped=true&"
import script from "./steps.vue?vue&type=script&lang=js&"
export * from "./steps.vue?vue&type=script&lang=js&"
import style0 from "./steps.vue?vue&type=style&index=0&id=6eea9872&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eea9872",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\linlin\\resbdqueryroom\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eea9872')) {
      api.createRecord('6eea9872', component.options)
    } else {
      api.reload('6eea9872', component.options)
    }
    module.hot.accept("./steps.vue?vue&type=template&id=6eea9872&scoped=true&", function () {
      api.rerender('6eea9872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/steps.vue"
export default component.exports